import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import "moment/locale/el";
import dynamic from "next/dynamic";
import { API_URL } from "@js-shared/lib/config/environment"
import { Container, Box } from "@material-ui/core";

// Dynamic imports
const StationDetails = dynamic(() => import("@components/StationDetails"),
  { ssr: true }
);

function StationsDetailsScreen(props) {
  return (
    <Container maxWidth="lg">
      <StationDetails station={props.station} seo={props.seo} />
    </Container>
  );
}

const noop = () => {};

const mapStateToProps = (state) => {
  return {
  };
};

export async function getServerSideProps(context) {
  try {
    const station_res = await axios.get(`${API_URL}/api/stations/get-station-by-slug/${context.query.slug_id}/`);
    const station = station_res.data;

    const seo_res = await axios.get(`${API_URL}/api/seo/get-model-metadata/`, {
      data: { model_id: station.id }
    });
    const seo = seo_res.data
    
    return { props: { station, seo } };

  } catch (error) {
    // Station was not found by slug, try to find it by ID
    try {
      const stationId = context.query.slug_id
      const station_res = await axios.get(`${API_URL}/api/stations/${stationId}/`);
      const station = station_res.data;
  
      const seo_res = await axios.get(`${API_URL}/api/seo/get-model-metadata/`, {
        data: { model_id: stationId }
      });
      const seo = seo_res.data
      
      return { props: { station, seo } };
  
    } catch (error) {
      // Station was not found by ID either, return Not Found error
      
      return {
        notFound: true,
      };
    }
  }
}

export default connect(
  mapStateToProps,
  {}
)(StationsDetailsScreen);
